import React, { Component } from 'react'
import MovieSearchForm from './MovieSearchForm'

class MovieSearchFormWithoutRouter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            query: ''
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleChange(e) {
        this.setState({query: e.target.value})
    }

    handleSubmit(e) {
        e.preventDefault();

        if(this.state.query && this.state.query.trim()) {
            window.location.href = this.props.programOverviewUrl + '?search=' + this.state.query.trim()
        }

        if(this.props.onSubmitSearch) {
            this.props.onSubmitSearch()
        }
    }

    render() {
        const { translation } = this.props

        return <MovieSearchForm
            textClass={this.props.textClass}
            translation={translation}
            query={this.state.query}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
        />
    }
}

export default MovieSearchFormWithoutRouter